import styled from 'styled-components/macro';

export const sliderWidth = 760;
export const slideWidth = 108;

export const SliderWrapper = styled.div`
  height: 74px;
  position: relative;
  padding: 0;
  margin: 0 -4px;

  &.has-arrows {
    padding: 0 50px;
    margin: 0;
  }

  .arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .arrow-left {
    left: 0;
  }

  .arrow-right {
    right: 0;
  }

  .embla {
    position: relative;
    max-width: ${sliderWidth}px;
  }

  .embla__viewport {
    overflow: hidden;
    width: 100%;
  }

  .embla__viewport.is-draggable {
    cursor: move;
    cursor: grab;
  }

  .embla__viewport.is-dragging {
    cursor: grabbing;
  }

  .embla__container {
    display: flex;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: default;
  }

  .embla__container.centered {
    justify-content: center;
    transform: translate3d(0, 0, 0) !important;
  }

  .embla__slide {
    min-width: ${slideWidth}px;
    height: 74px;
    position: relative;
    padding: 0 4px;
  }
`;
